interface DiagnosisHeadingParts {
  source: string;
  subsite?: string | null;
  findings?: string | null;
  procedure?: string | null;
  uppercaseAnatomy?: boolean;
}

export function formatDiagnosisHeading(parts: DiagnosisHeadingParts): string {
  const source = parts.uppercaseAnatomy
    ? parts.source.toUpperCase()
    : parts.source;
  const subsite = parts.subsite?.trim();
  const anatomy = subsite
    ? `${source}, ${parts.uppercaseAnatomy ? subsite.toUpperCase() : subsite}`
    : source;
  const findings = parts.findings?.trim() ? `, ${parts.findings.trim()}` : "";
  const procedure = parts.procedure ? ` (${parts.procedure})` : "";
  return `${anatomy}${findings}${procedure}:`;
}
